// src/pages/CRMContacts.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { contactsAPI } from '../services/api';
import toast from 'react-hot-toast';
import {
  Search, RefreshCw, Mail, Phone, Building2, Eye, Users, X,
  ChevronLeft, ChevronRight,Filter
} from 'lucide-react';
import { avatarColorClass } from '../utils/helpers';

const PAGE_SIZE = 25;

const STATUS_META = {
  INTERLOCUTEUR:  { label: 'Interlocuteur',  color: '#3B82F6' },
  DECISIONNAIRE:  { label: 'Décisionnaire',  color: '#8B5CF6' },
  PROSPECT:       { label: 'Prospect',        color: '#F59E0B' },
  INACTIF:        { label: 'Inactif',         color: '#6B7280' },
};

export default function CRMContacts() {
  const navigate  = useNavigate();
  const [contacts, setContacts] = useState([]);
  const [total,    setTotal]    = useState(0);
  const [loading,  setLoading]  = useState(true);
  const [search,   setSearch]   = useState('');
  const [page, setPage] = useState(1);

const [filters, setFilters] = useState({
  status: '',
  company: '',
  job_title: ''
});

const [showFilters, setShowFilters] = useState(false);
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
   const params = {
  search: search || undefined,
  skip: (page - 1) * PAGE_SIZE,
  limit: PAGE_SIZE,
};

if (filters.status)
  params.status = filters.status;

if (filters.company)
  params.company = filters.company;

if (filters.job_title)
  params.job_title = filters.job_title;

const res = await contactsAPI.list(params);
      setContacts(res.data.items || []);
      setTotal(res.data.total   || 0);
    } catch { toast.error('Erreur chargement contacts'); }
    finally { setLoading(false); }
  },  [search, page, filters]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const totalPages = Math.ceil(total / PAGE_SIZE);
const hasFilters = Object.values(filters).some(Boolean);
  const handleSearch = (e) => {
    if (e.key === 'Enter') { setPage(1); fetchData(); }
  };

  return (
    <div>
      <div className="page-header">
        <div className="page-header-left">
          <h1>CRM — Contacts</h1>
          <p>{total} contact{total !== 1 ? 's' : ''} clients et prospects</p>
        </div>
        <div className="page-header-actions">
         <button
  className="btn btn-secondary"
  onClick={() => setShowFilters(s => !s)}
>
  <Filter size={15}/>
  Filtres

  {hasFilters && (
    <span
      style={{
        marginLeft:4,
        background:'#3B82F6',
        color:'white',
        borderRadius:'50%',
        width:16,
        height:16,
        display:'inline-flex',
        alignItems:'center',
        justifyContent:'center',
        fontSize:'0.6rem'
      }}
    >
      {Object.values(filters).filter(Boolean).length}
    </span>
  )}
</button>

<button
  className="btn btn-secondary"
  onClick={() => {
    setPage(1);
    fetchData();
  }}
>
  <RefreshCw size={15}/>
</button>
        </div>
      </div>

      {/* Recherche */}
      <div style={{ display:'flex', gap:10, marginBottom:16 }}>
        <div style={{ position:'relative', flex:1 }}>
          <Search size={14} style={{ position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', color:'var(--text-muted)' }}/>
          <input
            style={{ paddingLeft:34, height:38, border:'1px solid var(--border)', borderRadius:8, fontSize:'0.875rem', outline:'none', width:'100%', boxSizing:'border-box', background:'var(--bg-elevated)', color:'var(--text-primary)' }}
            placeholder="Nom, poste, email, société…"
            value={search}
            onChange={e => { setSearch(e.target.value); setPage(1); }}
            onKeyDown={handleSearch}
          />
        </div>
       {(search || hasFilters) && (
          <button className="btn btn-ghost btn-sm" onClick={() => {
  setSearch('');
  setPage(1);

  setFilters({
    status:'',
    company:'',
    job_title:''
  });
}}>
            <X size={14}/> Effacer
          </button>
        )}
      </div>
{showFilters && (
  <div className="card" style={{ marginBottom:16, padding:'14px 16px' }}>
    <div
      style={{
        display:'grid',
        gridTemplateColumns:'repeat(3,1fr)',
        gap:10
      }}
    >

      <div>
        <label style={lbl}>Statut</label>

        <select
          className="filter-select"
          style={{ width:'100%' }}
          value={filters.status}
          onChange={e =>
            setFilters(p => ({
              ...p,
              status:e.target.value
            }))
          }
        >
          <option value="">Tous</option>

          {Object.entries(STATUS_META).map(([k,v]) => (
            <option key={k} value={k}>
              {v.label}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label style={lbl}>Société</label>

        <input
          style={inp}
          placeholder="Société..."
          value={filters.company}
          onChange={e =>
            setFilters(p => ({
              ...p,
              company:e.target.value
            }))
          }
        />
      </div>

      <div>
        <label style={lbl}>Poste</label>

        <input
          style={inp}
          placeholder="Poste..."
          value={filters.job_title}
          onChange={e =>
            setFilters(p => ({
              ...p,
              job_title:e.target.value
            }))
          }
        />
      </div>

    </div>
  </div>
)}
      <div style={{ fontSize:'0.8125rem', color:'var(--text-muted)', marginBottom:12 }}>
        {loading ? 'Chargement…' : `${total} contact${total!==1?'s':''} ${totalPages>1?`— page ${page}/${totalPages}`:''}`}
      </div>

      {loading ? (
        <div style={{ display:'flex', justifyContent:'center', padding:'48px', gap:10, color:'var(--text-muted)' }}>
          <div className="spinner"/>Chargement…
        </div>
      ) : contacts.length === 0 ? (
        <div className="card" style={{ textAlign:'center', padding:'48px' }}>
          <Users size={36} style={{ opacity:.3, marginBottom:12 }}/>
          <div style={{ fontWeight:600, marginBottom:6 }}>Aucun contact trouvé</div>
        </div>
      ) : (
        <div className="card" style={{ overflow:'hidden' }}>
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', minWidth:640 }}>
              <thead>
                <tr style={{ background:'var(--bg-elevated)', borderBottom:'1px solid var(--border)' }}>
                  {['Nom','Poste','Statut','Société','Email','Téléphone',''].map(h => (
                    <th key={h} style={{ padding:'10px 14px', textAlign:'left', fontSize:'0.72rem', fontWeight:700, color:'var(--text-muted)', whiteSpace:'nowrap', textTransform:'uppercase', letterSpacing:'0.04em' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {contacts.map(c => {
                  const sm = STATUS_META[c.status] || { label: c.status, color: '#6B7280' };
                  return (
                    <tr key={c.id}
                      style={{ borderBottom:'1px solid var(--border)', cursor:'pointer', transition:'background .15s' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-elevated)'}
                      onMouseLeave={e => e.currentTarget.style.background = ''}
                      onClick={() => navigate(`/crm-contacts/${c.id}`)}
                    >
                      <td style={{ padding:'10px 14px' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                          <div className={`avatar avatar-sm ${avatarColorClass(c.full_name || '')}`}>{(c.full_name||'?')[0]}</div>
                          <div>
                            <div style={{ fontWeight:600, fontSize:'0.875rem' }}>{c.full_name}</div>
                            {c.civilite && <div style={{ fontSize:'0.72rem', color:'var(--text-muted)' }}>{c.civilite}</div>}
                          </div>
                        </div>
                      </td>
                      <td style={{ padding:'10px 14px', fontSize:'0.82rem', color:'var(--text-secondary)' }}>{c.job_title || '—'}</td>
                      <td style={{ padding:'10px 14px' }}>
                        <span style={{ whiteSpace:'nowrap', fontSize:'0.72rem', fontWeight:700, padding:'2px 8px', borderRadius:6, color:sm.color, background:`${sm.color}18` }}>{sm.label}</span>
                      </td>
                      <td style={{ padding:'10px 14px', fontSize:'0.82rem' }}>
                        {c.company_name
                          ? <div style={{ display:'flex', alignItems:'center', gap:5 }}><Building2 size={12} color="var(--text-muted)"/>{c.company_name}</div>
                          : <span style={{ color:'var(--text-muted)' }}>—</span>}
                      </td>
                      <td style={{ padding:'10px 14px', fontSize:'0.8rem' }}>
                        {c.email
                          ? <a href={`mailto:${c.email}`} onClick={e=>e.stopPropagation()} style={{ display:'flex', alignItems:'center', gap:4, color:'#3B82F6', textDecoration:'none' }}><Mail size={12}/>{c.email}</a>
                          : <span style={{ color:'var(--text-muted)' }}>—</span>}
                      </td>
                      <td style={{ padding:'10px 14px', fontSize:'0.8rem', color:'var(--text-secondary)' }}>
                        {c.phone ? <div style={{ display:'flex', alignItems:'center', gap:4 }}><Phone size={12}/>{c.phone}</div> : '—'}
                      </td>
                      <td style={{ padding:'10px 14px' }}>
                        <Eye size={14} color="var(--text-muted)"/>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, marginTop:20 }}>
          <button className="btn btn-secondary btn-sm" disabled={page===1} onClick={() => setPage(p=>p-1)}><ChevronLeft size={14}/></button>
          <span style={{ fontSize:'0.85rem', color:'var(--text-muted)', minWidth:80, textAlign:'center' }}>Page {page} / {totalPages}</span>
          <button className="btn btn-secondary btn-sm" disabled={page===totalPages} onClick={() => setPage(p=>p+1)}><ChevronRight size={14}/></button>
        </div>
      )}
    </div>
  );
}
const lbl = {
  display:'block',
  fontSize:'0.75rem',
  fontWeight:600,
  color:'var(--text-muted)',
  marginBottom:4,
  textTransform:'uppercase',
  letterSpacing:'0.04em'
};

const inp = {
  width:'100%',
  padding:'8px 10px',
  border:'1.5px solid var(--border)',
  borderRadius:7,
  fontSize:'0.875rem',
  boxSizing:'border-box',
  fontFamily:'inherit',
  outline:'none',
  background:'var(--bg-elevated)',
  color:'var(--text-primary)'
};
